
import { useState ,createContext, useLayoutEffect } from "react";
import { addData, addProductToCategory, getWebsite, removeData, updateBusinessInfo, updateData, updateDataComplex, updatePersonalInfo } from "../firebase/firebase_functions";
import BranchCard from "../components/dashboard/branch_form/BranchCard";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../firebase/firebase";

export const DashboardContext = createContext(null);

// ==========================
// Dashboard context provider
// ==========================
export default function DashboardContextProvider({children}) {
    
    // Main
    const [isLoading, setIsLoading] = useState(false);
    
    // Jobs form
    const [isAddJob, setIsAddJob] = useState(false);
    const [jobTitle, setJobTitle] = useState("");
    const [jobDesc, setJobDesc] = useState("");
    const [jobDetails, setJobDetails] = useState("");
    const [jobRequirement, setJobRequirement] = useState("");
    const [jobBenefit, setJobBenefit] = useState("");
    const [jobReqs, setJobReqs] = useState([]);
    const [jobBenefits, setJobBenefits] = useState([]);

    // Products form
    const [productsList, setProductsList] = useState([]);
    const [isAddProduct, setIsAddProduct] = useState(false);
    const [productName, setProductName] = useState("");
    const [productDesc, setProductDesc] = useState("");
    const [productPrice, setProductPrice] = useState("");
    const [productHasAmount, setProductHasAmount] = useState("");
    const [productAmount, setProductAmount] = useState(0);
    const [productCompanyName, setProductCompanyName] = useState("");
    const [productCategoryID, setProductCategoryID] = useState("");
    const [productCategoryName, setProductCategoryName] = useState("");
    const [currentProduct, setCurrentProduct] = useState(()=>{
        const cp = localStorage.getItem("webingo_dashboard_currentProduct");
        return cp ? JSON.parse(cp) : {};
    });
    
    
    // Category form
    const [isAddCategory, setIsAddCategory] = useState(false);
    const [categoryName, setCategoryName] = useState("");

    // HomeHeader form
    const [changeHeadersFlag, setChangeHeadersFlag] = useState(false);

    // Branches form
    const [isAddBranch, setIsAddBranch] = useState(false);
    const [branchCity, setBranchCity] = useState("");
    const [branchAddress, setBranchAddress] = useState("");
    const [branchHours, setBranchHours] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    
    // Change branch data
    const [branchToEdit, setBranchToEdit] = useState("");
    const [branchDay, setBranchDay] = useState("");
    const [branchStart, setBranchStart] = useState("");
    const [branchEnd, setBranchEnd] = useState("");
    const [branchUpdateFlag, setBranchUpdateFlag] = useState(false);
    
    // About form
    const [aboutFlag, setAboutFlag] = useState(false);

    // Social form
    const [socialFlag, setSocialFlag] = useState(false);
    
    // Theme form
    const [themeFlag, setThemeFlag] = useState(false);
    const [primaryFlag,setPrimaryFlag] = useState(false);
    const [secondaryFlag,setSecondaryFlag] = useState(false);
    const [accentFlag,setAccentFlag] = useState(false);
    
    // Navbar form
    const [navbarFlag, setNavbarFlag] = useState(false);
    
    useLayoutEffect(()=>{
        localStorage.setItem("webingo_dashboard_currentProduct",JSON.stringify(currentProduct));
    },[currentProduct])

    // =============
    // Add functions
    // =============
    // Adding a new job
    const handleAddJob = async(website, setToastMessage, messagesOptions )=>{
        if (!website){
            setToastMessage(messagesOptions.wrong);
            return false;
        }
        if(!jobTitle || !jobDesc || !jobDetails || !jobReqs || !jobBenefits){
            setToastMessage(messagesOptions.aware);
            return false;
        }
        if(jobTitle.length === 0 || jobDesc.length === 0 || jobDetails.length === 0 || jobReqs.length === 0 || jobBenefits.length === 0){
            setToastMessage(messagesOptions.empty);
            return false;
        }
        setIsAddJob(true);
        try{
            const job = {
                _id: Date.now(),
                createdAt: new Date(),
                updatedAt: new Date(),
                title:jobTitle,
                desc:jobDesc,
                details:jobDetails,
                requirements:jobReqs,
                benefits:jobBenefits
            }
            const res = await addData(website.id, "settings.jobs", job);
            if(res){
                setToastMessage(messagesOptions.ok);
            }
            else{
                setToastMessage(messagesOptions.wrong);
            }
            return res;
        }catch(err){
            console.error("Error adding job: "+err);
            setToastMessage(messagesOptions.wrong);
            return false;
        } finally{
            setIsAddJob(false);
        }
    }
    // Adding a new product to a category selected
    const handleAddProduct = async(website, path, setToastMessage, messagesOptions)=>{
        if (!website){
            setToastMessage(messagesOptions.wrong);
            return false;
        }
        if(!productName || !productDesc || !productPrice || !productCategoryID){
            setToastMessage(messagesOptions.aware);
            return false;
        }
        if(productName.length === 0 || productDesc.length === 0 || productPrice.length === 0 || productCategoryID.length === 0){
            setToastMessage(messagesOptions.empty);
            return false;
        }
        setIsAddProduct(true);
        try{
            var categoryImg = null;
            website?.settings?.categories.map((cat)=>{
                if(cat._id===productCategoryID){
                    categoryImg = cat.imgURL;
                }
                return cat;
            })
            const product={
                _id: Date.now(),
                name:productName,
                desc:productDesc,
                disValue:0,
                hasAmount: productHasAmount===true ? true : false,
                amount:productHasAmount ? (parseInt(productAmount)<=0 ? 0 : parseInt(productAmount)) : 1,
                hasDiscount: false,
                imgURL:path || null,
                categoryImgURL:categoryImg,
                price: parseInt(productPrice),
                company:productCompanyName !== "" ? productCompanyName : "כללי",
                categoryID:productCategoryID,
                categoryName:productCategoryName,
                createdAt: new Date(),
                updatedAt: new Date(),
            }
            const res = await addProductToCategory(website.id, productCategoryID, product);
            if(res){
                setToastMessage(messagesOptions.ok);
            }
            else{
                setToastMessage(messagesOptions.wrong);
            }
            return res;
        } catch(err){
            console.error("Error adding product: "+err);
            setToastMessage(messagesOptions.wrong);
            return false;
        } finally{
            setIsAddProduct(false);
        }
    }
    // Adding a new category
    const handleAddCategory = async(website, path, setToastMessage, messagesOptions )=>{
        if (!website){
            setToastMessage(messagesOptions.wrong);
            return false;
        }
        if(!categoryName){
            setToastMessage(messagesOptions.aware);
            return false;
        }
        if(categoryName.length === 0){
            setToastMessage(messagesOptions.empty);
            return false;
        }
        setIsAddCategory(true);
        try{
            const newCategory = {
                _id: Date.now(),
                createdAt: new Date(),
                updatedAt: new Date(),
                imgURL:path || null,
                products:[],
                name:categoryName,
            }
            const res = await addData(website.id, "settings.categories", newCategory);
            if(res){
                setToastMessage(messagesOptions.ok);
            }
            else{
                setToastMessage(messagesOptions.wrong);
            }
            return res;
        } catch(err){
            console.error("Error adding category: "+err);
            setToastMessage(messagesOptions.wrong);
            return false;
        } finally{
            setIsAddCategory(false);
        }
    }
    // AAdding a new branch
    const handleAddBranch = async(website, setToastMessage, messagesOptions )=>{
        if (!website){
            setToastMessage(messagesOptions.wrong);
            return false;
        }
        if(!branchCity || !branchAddress){
            setToastMessage(messagesOptions.aware);
            return false;
        }
        if(branchCity.length === 0 || branchAddress.length === 0 ){
            setToastMessage(messagesOptions.empty);
            return false;
        }
        setIsAddBranch(true);
        try{
            const branch = {
                _id: Date.now(),
                createdAt: new Date(),
                updatedAt: new Date(),
                city: branchCity,
                address: branchAddress,
                isOpen:false,
                week: [
                    {
                        day: "יום א'",
                        isOpen: false,
                        startAt: null, 
                        endAt: null, 
                    },
                    {
                        day: "יום ב'",
                        isOpen: false,
                        startAt: null, 
                        endAt: null, 
                    },
                    {
                        day: "יום ג'",
                        isOpen: false,
                        startAt: null, 
                        endAt: null, 
                    },
                    {
                        day: "יום ד'",
                        isOpen: false,
                        startAt: null, 
                        endAt: null, 
                    },
                    {
                        day: "יום ה'",
                        isOpen: false,
                        startAt: null, 
                        endAt: null, 
                    },
                    {
                        day: "יום ו'",
                        isOpen: false,
                        startAt: null, 
                        endAt: null, 
                    },
                    {
                        day: "יום ש'",
                        isOpen: false,
                        startAt: null, 
                        endAt: null, 
                    }
                ],
            }
            const res = await addData(website.id, "settings.branches", branch)
            if(res){
                setToastMessage(messagesOptions.ok);
            }
            else{
                setToastMessage(messagesOptions.wrong);
            }
            return res;
        } catch (err) {
            console.error('Error adding branch: ', err);
            setToastMessage(messagesOptions.wrong);
            return false;
        } finally {
            setIsAddBranch(false);
        }
    }
    // Adding a new section to the about page
    const handleAddAboutSection = async(website, setToastMessage, messagesOptions)=>{
        setAboutFlag(true);
        try {
            const newSection = {
                sectionID: Date.now(),
                header:"",
                content:""
            }
            const res = await addData(website.id, "settings.about", newSection);
            if(res){
                setToastMessage(messagesOptions.ok);
            }
            else{
                setToastMessage(messagesOptions.failed);
            }
        } catch (err) {
            console.error("Error on adding about section: "+err);
            setToastMessage(messagesOptions.wrong);
        } finally{
            setAboutFlag(false);
        }
    }

    
    const generatePage = async(websiteId, pageId, prompt, websiteContext) => {
        const generate = httpsCallable(functions, "generatePage");

        const result = await generate({
            websiteId,
            pageId,
            prompt,
            websiteContext
        });
        console.log("Data from generate action: ",result.data);
        return result.data;
    }


    // =====================
    // Update data functions
    // =====================
    // updating the home page main and sub headers
    const handleUpdateHomeHeader = async(website, newData, setToastMessage, messagesOptions)=>{
        setChangeHeadersFlag(true);
        try {
            const res = await updateData(website.id, "settings.homeHeaders", newData)
            if(!res){
                setToastMessage(messagesOptions.failed);
                return;
            }
            else{
                setToastMessage(messagesOptions.ok);
            }
        } catch (error) {
            console.error("Error on update home header on dashboard context: ",error);
            setToastMessage(messagesOptions.wrong);
            setChangeHeadersFlag(false);
        } finally{
            setChangeHeadersFlag(false);
        }
    }


    // When adding new product => handles the catch of category selected
    const handleSetCategory = (e, website)=>{
        const inputVal = e.target.value;
        website?.settings?.categories?.map((val)=>{
            if(val.name === inputVal){
                setProductCategoryName(val.name);
                setProductCategoryID(val._id);
            }
            return val;
        })
    }
    // When changing a branch status open/close => update the status first to display/hide
    // The activity hours of the branch
    const handleBranchStatusChange = async(website, branchID, setToastMessage, messagesOptions )=>{
        try{
            const branches = website?.settings?.branches;
            const updated = await Promise.resolve(branches.map((br)=>{
                if(br._id === branchID){
                    return {
                        ...br,
                        isOpen: !br.isOpen
                    }
                }
                return br;
            }))
            const res = await updateData(website.id, "settings.branches", updated, false);
            if(res){
                setToastMessage(messagesOptions.reload);
            }
            if(!res){
                setToastMessage(messagesOptions.wrong);
            }
        } catch(err){
            console.error("Error on change branch status: \n"+err);
            setToastMessage(messagesOptions.wrong);
        }
    }
    // When branch is open and activity days/hours made some changes => update on db
    const handleSetBranchData = async(website, branchID, branchActivity, setToastMessage, messagesOptions)=>{
        if(!website || !branchID || !branchActivity){
            setToastMessage(messagesOptions.wrong);
            return;
        }
        setBranchUpdateFlag(true);
        try{
            const res = await updateDataComplex(website.id, website.settings.branches, branchID, "week", branchActivity, "settings.branches");
            if(res){
                setToastMessage(messagesOptions.ok);
            }
            else{
                setToastMessage(messagesOptions.failed);
            }
        } catch(err){
            console.error("Error on set branch data: "+err);
            setToastMessage(messagesOptions.wrong);
        } finally{
            setBranchUpdateFlag(false);
        }
    }
    // Change social data at social form
    const handleChangeSocial=async(website, instagramFlag, instagramLink, facebookFlag, facebookLink, whatsappFlag, whatsappLink, setToastMessage, messagesOptions )=>{
        setSocialFlag(true);
        try{
        const socialObj={
            instagram:{
            include: instagramFlag,
            url: instagramLink
            },
            facebook:{
            include: facebookFlag,
            url: facebookLink
            },
            whatsapp:{
            include: whatsappFlag,
            url: whatsappLink
            }
        }
        const res = await updateData(website.id, "settings.social", socialObj);
        if(res){
            setToastMessage(messagesOptions.ok);
        }
        else{
            setToastMessage(messagesOptions.failed);
        }
        } catch(err){
            console.error("Error on change social: "+err);
            setToastMessage(messagesOptions.wrong);
        } finally{
            setSocialFlag(false);
        }
    }
    // Change theme data at theme form
    const handleChangeTheme=async(website, primary, secondary, accent, setToastMessage, messagesOptions )=>{
        setThemeFlag(true);
        try{
            const themeObj = {
                primary_color:primary,
                secondary_color:secondary,
                accent_color:accent
            }
            const res = await updateData(website.id, "settings.theme", themeObj);
            if(res){
                setToastMessage(messagesOptions.ok);
            }
            else{
                setToastMessage(messagesOptions.failed);
            }
        } catch(err){
            console.error("Error on change theme: "+err);
            setToastMessage(messagesOptions.wrong);
        } finally{
            setThemeFlag(false);
        }
    }
    // Change navbar data at navbar form
    const handleChangeNavbar = async(website, homePageName, homeFlag, categoriesPageName, categoriesFlag, branchesPageName, branchesFlag, jobsPageName, jobsFlag, helpdeskPageName, helpdeskFlag, setToastMessage, messagesOptions)=>{
        setNavbarFlag(true);
        try{
            const navbar = [
                {
                    btnName:homePageName,
                    include:homeFlag,
                    link:website.settings.navbar[0].link,
                },
                {
                    btnName:categoriesPageName,
                    include:categoriesFlag,
                    link:website.settings.navbar[1].link,
                },
                {
                    btnName:branchesPageName,
                    include:branchesFlag,
                    link:website.settings.navbar[2].link,
                },
                {
                    btnName:jobsPageName,
                    include:jobsFlag,
                    link:website.settings.navbar[3].link,
                },
                {
                    btnName:helpdeskPageName,
                    include:helpdeskFlag,
                    link:website.settings.navbar[4].link,
                },
            ]
            const res = await updateData(website.id, "settings.navbar", navbar);
            if(res){
                setToastMessage(messagesOptions.ok);    
            }
            else{
                setToastMessage(messagesOptions.failed);    
            }
        }
        catch(err){
            console.error("Error on change navbar: "+err);
            setToastMessage(messagesOptions.wrong);
        } finally{
            setNavbarFlag(false);
        }
    }
    // Change about data at about from
    const handleSetAbout = async(website, content, setToastMessage, messagesOptions )=>{
        try {
            const res = await updateData(website.id, "settings.about", content);
            if(res){
                setToastMessage(messagesOptions.ok);
            }
            else{
                setToastMessage(messagesOptions.failed);
            }
            return res;
        } catch (err) {
            console.error("Error on setting about: "+err);
            setToastMessage(messagesOptions.wrong);
            return false;
        }
    }
    // Change the main website details at business info form
    const handleChangeBusinessInfo = async(website, newBusinessData, setSaveFlag, setEditFlag, setToastMessage, messagesOptions)=>{
        setSaveFlag(true);
        try{
            const res = await updateBusinessInfo(website?.id, newBusinessData);
            if(res)setToastMessage(messagesOptions.ok)
            else setToastMessage(messagesOptions.failed);
            return res;
        } catch(err){
            console.error("error on changing personal info: ",err);
            setToastMessage(messagesOptions.wrong);
            return false;
        } finally{
            setEditFlag(false);
            setSaveFlag(false);
        }
    }
    // Change the website's owner main info at personal info form
    const handleChangePersonalInfo = async(website, newPersonalData, setSaveFlag, setEditFlag, setCurrentManager, setToastMessage, messagesOptions)=>{
        setSaveFlag(true);
        try{
            const res = await updatePersonalInfo(website, newPersonalData, website?.owner?.password, setCurrentManager, setToastMessage, messagesOptions);
            if(res) setToastMessage(messagesOptions.ok);
            else setToastMessage(messagesOptions.failed);
            return res;
        } catch(err){
            console.error("error on changing personal info: ",err);
            setToastMessage(messagesOptions.wrong);
            return false;
        } finally{
            setEditFlag(false);
            setSaveFlag(false);
        }
    }

    // At dashboard product edit page => dynamic function that changes the
    // Requested parameter of the product according to data received
    const handleUpdateProduct = async(website, productID, categoryID, _parameter, _content, setToastMessage, messagesOptions)=>{
        try {
            const categories = website?.settings?.categories;
            var updatedCategories = null;
            // Specifically for category name, needs to delete product from current category
            // And add it to the new category requested, also change product parameters
            // Of categoryID, categoryImgURL, and categoryName
            if(_parameter === "categoryName"){
                // Filter to remove product and catch it seperatly
                var productToMove = null;
                const filtered = categories.map(cat=>{
                    if(cat._id===categoryID){
                        return {
                            ...cat,
                            products: cat.products.filter(prod =>{
                                if(prod._id===productID){
                                    productToMove = {...prod};
                                }
                                return prod._id !== productID;
                            })
                        }
                    }
                    return cat;
                })
                // If didn't catch/found set toast message and return
                if(productToMove===null || productToMove===undefined){
                    setToastMessage(messagesOptions.failed);
                    return; 
                }
                // If catch/found => add to new category and update parameters
                updatedCategories = filtered.map(cat=>{
                    if(cat.name === _content){
                        const newProducts = {
                            ...productToMove,
                            categoryID: cat._id,
                            categoryImgURL: cat.categoryImgURL ? cat.categoryImgURL : null,
                            categoryName: cat.name,
                        }
                        return {
                            ...cat,
                            products: [...cat.products, newProducts]
                        }
                    }
                    return cat;
                })
            }
            // At any other case that is not category name => update requested parameter
            else{
                updatedCategories = await Promise.resolve(categories.map(cat => {
                    if(cat?._id === categoryID){
                        return {
                            ...cat,
                            products: cat.products.map(prod => {
                                if(prod._id === productID){
                                    const updatedProduct = {
                                        ...prod,
                                        updatedAt: new Date(),
                                        [_parameter]: _content
                                    }
                                    setCurrentProduct(updatedProduct);
                                    return updatedProduct;
                                }
                                return prod;
                            })
                        }
                    }
                    return cat;
                }))
            }
            // If didn't succeed to catch an update => set toast message and return
            if(updatedCategories===null || updatedCategories===undefined){
                setToastMessage(messagesOptions.failed);
                return;
            }
            // Else => attempt to update on db and set toast message to client
            const res = await updateData(website.id, "settings.categories", updatedCategories);
            if(res) setToastMessage(messagesOptions.ok);
            else setToastMessage(messagesOptions.failed);
        } catch (err) {
            console.error("Error on updating product: \n"+err);
            setToastMessage(messagesOptions.wrong);
        }
    }
    const handleUpdateCategoryName = async(website, categoryID, newName, setCurrentWebsite)=>{
        try {
            await updateDataComplex(website.id, website.settings.categories, categoryID, "name", newName, "settings.categories");
            const updatedWebsite = await getWebsite("settings.domain", website?.settings?.domain);
            setCurrentWebsite(updatedWebsite);
        } catch (error) {
            console.error("Error on attempt to change category name at dashboard context: ",error)
        }
    }

    // =====================
    // delete data functions
    // =====================
    // Product delete from category
    const handleDeleteProduct =async(_website, _item, setToastMessage, messagesOptions, setEditPage, setCurrentCard)=>{
        
        if(!_website||_website===null||_website===undefined)return;
        try {
            // Filter the categories array to move the product requested
            const filteredArray = await Promise.all(_website?.settings?.categories?.map((cat)=>{
                if(cat._id === _item.categoryID){
                    const updatedProducts = cat?.products?.filter((prod)=>{
                        return prod._id !== _item._id;
                    })
                    return {
                        ...cat,
                        products: updatedProducts
                    }
                }
                return cat;
            }));
            // Then attempt to update with filtered array
            const res = await updateData(_website.id, "settings.categories", filteredArray);
            if(res){
                setToastMessage(messagesOptions.ok);
                window.scrollTo({
                    top:0,
                    behavior:"smooth"
                })
                await new Promise(resolve => setTimeout(resolve, 800));
                setEditPage(3);
                setCurrentCard("dashboardCard_products");
            }
            else{
                setToastMessage(messagesOptions.failed);
            }
        } catch (error) {
            console.error("Error on delete product: ",error);
            setToastMessage(messagesOptions.wrong);
        }
    }
    // Function to delete any item on requested path of document with given ID
    const handleDeleteItem=async(_websiteID, _path, _item, setToastMessage, messagesOptions)=>{
        try {
            const res = await removeData(_websiteID, _path, _item);
            if(!res){
                setToastMessage(messagesOptions.failed);
            }
            else{
                setToastMessage(messagesOptions.itemDeleted);
            }
        } catch (error) {
            console.error("Error on delete item: ",error);
            setToastMessage(messagesOptions.failed);
        }
    }

    // function to delete the owner user and the whole website data from collection, storage and authentication
    const handleDeleteWebsite =async(website, setShowMsg, logout, nav)=>{
        try {

            if (!auth.currentUser) {
                console.error("User not authenticated");
                return;
            }
            const res = await fetch(
            `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECTID}.cloudfunctions.net/adminDeleteUserResources`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        websiteID: website.id,
                        userUID: website.data.owner.uid,
                    }),
                }
            );
            if(res.success){
                await new Promise(resolve => setTimeout(resolve, 600));
                logout(nav);
                localStorage.removeItem("webingo_currentWebsite");
                localStorage.removeItem("webingo_currentManager");
                localStorage.removeItem("webingo_currentManagerUID");
            }
        } catch (error) {
            console.error("Error on deleting website at dashboard context: ",error);
        } finally{
            setShowMsg(false)
        }
    }


    // ==================
    // deployment helpers
    // ==================
    // At jobs page => an helper to deploy lists of benefits/requirements
    const deployList = (website, list, setList)=>{
        if(!list || list === null || list.length === 0){
            return null;
        }
        return <div className='dashboardForm_list'>
            {list.map((_content,inx)=>{
                return <div key={`dashboardForm_list_${_content}_item_inx_${inx}`} className='dashboardForm_list_item' style={{backgroundColor:website?.settings?.theme?.primary_color, color:website?.settings?.theme?.accent_color}}>
                    <div className='dashboardForm_list_item_x' onClick={()=>{
                        const filtered = list.filter((val,index)=>{return inx !== index});
                        setList(filtered);
                    }} style={{backgroundColor:website?.settings?.theme?.accent_color, color:website?.settings?.theme?.primary_color}}>X</div>
                    <div className='dashboardForm_list_item_content'>{_content}</div>
                </div>
            })}
        </div>
    }
    // At branches form => and helper to deploy branches cards
     const deployBranches = (website)=>{
        try {
            const branches = website?.settings?.branches || [];
            // Has no branches => return header
            if(branches.length === 0){
                return <h2>עדיין לא קיימים סניפים</h2>
            }
            // Has any search term for branch => filter array
            // Else just return the regular array
            const s = searchTerm.trim().toLowerCase();
            const filtered = s==="" ? branches : branches.filter((br)=>{
                return br.city.trim().toLowerCase().includes(s) || br.address.trim().toLowerCase().includes(s);
            })
            // Didn't found a branch that fits the search term => return header
            if(filtered.length === 0){
                return <h2 className='branchList_search_notFound'>לא נמצאו סניפים התואמים לחיפוש</h2>
            }
            // Return the list of branch cards according to array
            return <div className='branchesList'>
                {filtered.map((branch, index)=>{
                return <BranchCard key={`branchCard_${branch._id}_${index}`} branch={branch} index={index}/>})}
            </div>
        } catch (error) {
            console.error("Error on deploy branches for branch form: ",error);
        }
    }


    const val ={

        // Main:
        isLoading,
        setIsLoading,
        handleDeleteItem,

        // homeHeaders:
        changeHeadersFlag,
        handleUpdateHomeHeader,

        // Job:
        isAddJob,
        handleAddJob,
        jobTitle,
        setJobTitle,
        jobDesc,
        setJobDesc,
        jobDetails,
        setJobDetails,
        jobRequirement,
        setJobRequirement,
        jobBenefit,
        setJobBenefit,
        jobReqs,
        setJobReqs,
        jobBenefits,
        setJobBenefits,
        deployList,

        // Products:
        productsList,
        setProductsList,
        isAddProduct,
        handleAddProduct,
        productCategoryID,
        setProductCategoryID,
        productCompanyName,
        setProductCompanyName,
        productDesc,
        setProductDesc,
        productName,
        setProductName,
        productHasAmount,
        setProductHasAmount,
        productAmount,
        setProductAmount,
        productPrice,
        setProductPrice,
        productCategoryName,
        setProductCategoryName,
        handleSetCategory,
        currentProduct,
        setCurrentProduct,
        handleUpdateProduct,
        handleDeleteProduct,

        // Category:
        isAddCategory,
        handleAddCategory,
        categoryName,
        setCategoryName,
        handleUpdateCategoryName,
        
        // Branch:
        isAddBranch,
        handleAddBranch,
        branchHours,
        setBranchHours,
        branchAddress,
        setBranchAddress,
        branchCity,
        setBranchCity,
        branchUpdateFlag,
        handleBranchStatusChange,

        // Branch data:
        handleSetBranchData,
        branchToEdit,
        setBranchToEdit,
        branchDay,
        setBranchDay,
        branchStart,
        setBranchStart,
        branchEnd,
        setBranchEnd,
        searchTerm,
        setSearchTerm,
        deployBranches,

        // About:
        handleAddAboutSection,
        handleSetAbout,
        aboutFlag,

        // Social:
        handleChangeSocial,
        socialFlag,

        // Theme:
        handleChangeTheme,
        primaryFlag,
        setPrimaryFlag,
        secondaryFlag,
        setSecondaryFlag,
        accentFlag,
        setAccentFlag,
        themeFlag,

        // Personal info:
        handleChangePersonalInfo,

        // Business info:
        handleChangeBusinessInfo,

        // Navbar:
        handleChangeNavbar,
        navbarFlag,

        // Subscription form:
        handleDeleteWebsite,

        // AI generated page:
        generatePage,
        // testGenerate,
    }

    return (
        <DashboardContext.Provider value={val}>
            {children}
        </DashboardContext.Provider>
    )
}
